import { Link } from 'react-router-dom';
import logo from '../assets/logo-transparent.png';

export default function Footer() {
  return (
    <footer className="fullbleed footer-v2">
      <svg
        className="footer-v2-waves"
        viewBox="0 0 1200 300"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        {Array.from({ length: 7 }).map((_, i) => (
          <path
            key={i}
            d={`M 1200 ${20 + i * 26} C 900 ${60 + i * 24}, 700 ${150 + i * 20}, 380 ${300 + i * 18}`}
            fill="none"
            stroke="rgba(255,255,255,0.14)"
            strokeWidth="1"
          />
        ))}
      </svg>

      <div className="footer-v2-inner">
        <div className="footer-v2-brand">
          <img className="footer-v2-logo" src={logo} alt="biolitec pharma" />
          <p className="footer-v2-descriptor">
            Advancing light-activated cancer treatment through photodynamic therapy.
          </p>
        </div>

        <div className="footer-v2-bar">
          <span>&copy; {new Date().getFullYear()} biolitec pharma ltd. All rights reserved.</span>
          <nav className="footer-v2-links">
            <Link to="/sitemap">Sitemap</Link>
            <Link to="/imprint">Imprint</Link>
            <Link to="/privacy-policy">Privacy policy</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}